import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../helpers/api_helper';
import { TeamBonusState, TeamBonusType } from './types';
import { toast } from 'react-toastify';
import { handleValidDate, handleValidTime } from '../../../helpers/helpers';
import { statusForTable } from '../MatchingBonus/slice';

export const getTeamBonus = createAsyncThunk(
  'getTeamBonus/fetch',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get(`/bonus/team`, {
      params
    });

    return response.data.data;
  }
);

export const exportTeamBonus = createAsyncThunk(
  'getTeamBonus/exportTeamBonus',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get('/bonus/team/export', {
      params
    });

    try {
      if (response?.data?.data?.userTeamBonuses) {
        const dataForExport = response?.data?.data?.userTeamBonuses.map(
          (u: any) => {
            return {
              id: u?.id,
              userId: u?.userId,
              userPackageId: u?.userPackageId,
              rank: u?.packageRank?.name,
              comissionPercent: u?.comissionPercent,
              position: u?.position === 0 ? 'Left' : 'Right',
              leftLegVolumeBefore: u?.leftLegVolumeBefore,
              rightLegVolumeBefore: u?.rightLegVolumeBefore,
              leftLegVolumeAfter: u?.leftLegVolumeAfter,
              rightLegVolumeAfter: u?.rightLegVolumeAfter,
              paidComissionAmount: u?.paidComissionAmount,
              comissionAmount: u?.comissionAmount,
              dateCreated: u?.dateCreated
                ? `${handleValidDate(u.dateCreated)}, ${handleValidTime(
                    u.dateCreated
                  )}`
                : '',
              status: statusForTable(u?.status)
            };
          }
        );

        return dataForExport;
      }

      if (response.data.message) {
        toast.success(response.data.message);
      }
    } catch (error: any) {
      toast.error(error.response.data.error);
    }
  }
);

export const paramsForExport = (searchParams: URLSearchParams) => {
  const params = searchParams;
  params.delete('countPerPage');
  params.delete('numberOfPage');
  params.delete('sortBy');
  params.delete('sortOrder');
  return params;
};

export const exportHeaders = [
  { label: 'Bonus ID', key: 'id' },
  { label: 'User', key: 'userId' },
  { label: 'Order Id', key: 'userPackageId' },
  { label: 'Package Rank', key: 'rank' },
  { label: 'Comission Percent', key: 'comissionPercent' },
  { label: 'Side Position', key: 'position' },
  { label: 'LLV Before', key: 'leftLegVolumeBefore' },
  { label: 'RLV Before', key: 'rightLegVolumeBefore' },
  { label: 'LLV after', key: 'leftLegVolumeAfter' },
  { label: 'RLV after', key: 'rightLegVolumeAfter' },
  { label: 'Amount', key: 'comissionAmount' },
  { label: 'Paid Comission Amount', key: 'paidComissionAmount' },
  { label: 'Date Created', key: 'dateCreated' },
  { label: 'Status', key: 'status' }
];

const initialState = {
  data: {},
  loading: false,
  dataForExport: [],
  loadingExport: false,
  totalCount: 0
} as TeamBonusState;

const getTeamBonusSlice = createSlice({
  name: 'getTeamBonus',
  initialState,
  reducers: {
    removeTeamBonusForExport(state) {
      state.dataForExport = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getTeamBonus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTeamBonus.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload;
      state.totalCount = payload.count;
    });
    builder.addCase(getTeamBonus.rejected, (state) => {
      state.loading = false;
    });

    //loading export
    builder.addCase(exportTeamBonus.pending, (state) => {
      state.loadingExport = true;
    });
    builder.addCase(exportTeamBonus.fulfilled, (state, { payload }) => {
      state.loadingExport = false;
      state.dataForExport = payload;
    });
    builder.addCase(exportTeamBonus.rejected, (state) => {
      state.loadingExport = false;
    });
  }
});

export const { removeTeamBonusForExport } = getTeamBonusSlice.actions;

export default getTeamBonusSlice.reducer;
